module.exports = __webpack_public_path__ + "img/rundholz-logo.7fb864de.svg";